import { render, staticRenderFns } from "./Die-Casting.vue?vue&type=template&id=5e7671c0&scoped=true"
import script from "./Die-Casting.vue?vue&type=script&lang=js"
export * from "./Die-Casting.vue?vue&type=script&lang=js"
import style0 from "./Die-Casting.vue?vue&type=style&index=0&id=5e7671c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7671c0",
  null
  
)

export default component.exports